module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "formSelect",
    staticClass: "uk-form-select"
  }, [_c('span'), _vm._v(" "), _c('i', {
    staticClass: "uk-icon-caret-down"
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": _vm.name
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value,
        "selected": item.value == _vm.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d18ffd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkSelect.vue
// module id = 298
// module chunks = 2